import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { PerformancePersonalLedgerView, RptPerformancePersonalLedgerView } from 'src/models/rptPerformancePersonalLedgerView';

//================|| PERFORMANCE PERSONAL LEDGER SLICE ||=================//
type PerformancePersonalLedgerState = {
    loading: boolean;
    error: ErrorInformation;
    performancePersonalLedgerView: PerformancePersonalLedgerView;
    rptPerformancePersonalLedgerView: RptPerformancePersonalLedgerView;
}

const initialState: PerformancePersonalLedgerState = {
    loading: true,
    error: null,
    performancePersonalLedgerView: {
        planModels: [],
        fullName: ''
    },
    rptPerformancePersonalLedgerView: null
};

export const getPerformancePersonalLedgerView = createAsyncThunk<PerformancePersonalLedgerView, {}, { rejectValue: ErrorInformation }>(
    "performancePersonalLedger/getPerformancePersonalLedgerView",
    async ({ }, { rejectWithValue }) => {
        try {
            const performancePersonalLedgerViewResponse = await axios.get<PerformancePersonalLedgerView>('PersonalLedger/getPerformancePersonalLedgerView');
            return performancePersonalLedgerViewResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getRptPerformancePersonalLedgerView = createAsyncThunk(
    "performancePersonalLedger/getRptPerformancePersonalLedgerView",
    async (planID: number, { rejectWithValue }) => {
        try {
            const rptPerformancePersonalLedgerViewResponse = await axios.get<RptPerformancePersonalLedgerView>(`PersonalLedger/getPerformancePersonalLedger?planID=${planID}`)
            return rptPerformancePersonalLedgerViewResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

const performancePersonalLedgerSlice = createSlice({
    name: 'performancePersonalLedger',
    initialState,
    reducers: {},
    extraReducers: {
        //get Performance Personal Ledger View
        [getPerformancePersonalLedgerView.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformancePersonalLedgerView.fulfilled.type]: (state, action) => {
            state.performancePersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getPerformancePersonalLedgerView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Rpt Performance Personal Ledger View
        [getRptPerformancePersonalLedgerView.pending.type]: (state) => {
            state.loading = true;
        },
        [getRptPerformancePersonalLedgerView.fulfilled.type]: (state, action) => {
            state.rptPerformancePersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getRptPerformancePersonalLedgerView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
    }
})
export default performancePersonalLedgerSlice